export default "__VITE_ASSET__ZQOEYBtR__"